import { useMutation } from 'react-query';
import usePlanStore from 'store/planStore';
import { useParams } from 'react-router-dom';
import { getMetaPredictionStatuses } from '../../../../../../../api/services/mediaPlanning/getMetaPredictionStatuses';

const useMetaPredictionStatuses = () => {
  const {
    alreadySavedPlanId,
    countryForms,
    updateCountryForm,
    updateMetaPredictionsState,
  } = usePlanStore();
  const { id } = useParams();

  const {
    mutate: getStatuses,
    mutateAsync: asyncGetStatuses,
    data: response,
    isLoading,
    isError,
  } = useMutation(
    async () => {
      return getMetaPredictionStatuses(id ?? alreadySavedPlanId ?? '');
    },
    {
      onSuccess: (res) => {
        const updatedCountryForm = usePlanStore.getState().countryForms;
        res?.forEach(
          ({
            country,
            mainStatus,
            partialStatus,
            metaCampaignId,
            mainPredictionId,
          }) => {
            updateCountryForm(country, {
              metaConfig: {
                ...updatedCountryForm[country].metaConfig,
                metaPredictionStatuses: {
                  mainPredictionStatus: mainStatus,
                  partialPredictionStatus: partialStatus,
                },
              },
            });

            updateMetaPredictionsState(
              country,
              metaCampaignId,
              mainPredictionId
            );
          }
        );
      },
    }
  );

  return {
    getMetaPredictionStatuses: getStatuses,
    asyncGetMetaPredictionStatuses: asyncGetStatuses,
    data: response,
    isLoading,
    isError,
  };
};

export default useMetaPredictionStatuses;
